import { Component, OnInit } from '@angular/core';
import { CURRENCY, INTERVAL, PRODUCTS } from './config';
import { Product } from './models/product';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  products = PRODUCTS;
  readonly intervalMs = INTERVAL * 60 * 1000; // milliseconds
  readonly currency = CURRENCY;
  isCrash = false;
  crashAudio = new Audio('./assets/audios/crash.mp3');

  ngOnInit(): void {
    this.randomizePrices(this.products, false);

    setInterval(
      () => this.randomizePrices(this.products),
      this.intervalMs
    );
  }

  private randomizePrices(products: Product[], withDelay = true): void {
    for (const product of products) {
      setTimeout(
        () => this.randomizePrice(product),
        withDelay ? this.randomNumberBetween(0, this.intervalMs / 2) : 0
      );
    }
  }

  private randomizePrice(product: Product): void {
    const previousPrice = product.price;
    product.price = this.randomNumberBetween(product.minPrice, product.maxPrice);

    if (!previousPrice || previousPrice === product.price) {
      product.variation = undefined;
    } else if (previousPrice > product.price) {
      product.variation = 'DOWN';
    } else if (previousPrice < product.price) {
      product.variation = 'UP';
    }
  }

  private randomNumberBetween(min: number, max: number): number {
    const nbDecimals = 10 ** Math.max(this.getNbDecimals(min), this.getNbDecimals(max));
    const minNumber = min * nbDecimals;
    const maxNumber = max * nbDecimals;

    return (minNumber + Math.floor(Math.random() * (maxNumber - minNumber + 1))) / nbDecimals;
  }

  private getNbDecimals(number: number): number {
    const decimalPart = number
      .toString()
      .split('.')
      .at(1);

    return decimalPart?.length ?? 0;
  }

  toggleCrash(): void {
    this.isCrash = !this.isCrash;

    if (this.isCrash) this.playCrashAudio();
    else this.crashAudio.pause();
  }

  private playCrashAudio(): void {
    this.crashAudio.load();
    this.crashAudio.loop = true;
    this.crashAudio.play();
  }
}
